import Tesla from '../../assets/tesla.png';
import Grid from '../../assets/grid.png';
import Crypto from '../../assets/crypto.png';
import Exo from '../../assets/exo.png';
import Disney from '../../assets/disney.png';
import Citations from '../../assets/citations.png';
import Zoo from '../../assets/Zoo.png';
import Jessy from '../../assets/jessy.png';

export const projectsData = [
  {
    id: 1,
    image: Disney,
    title: 'Disney Plus Clone',
    category: 'React',
    demo: 'https://github.com/r2r90/Dysney-Clone',
  },
  {
    id: 2,
    image: Tesla,
    title: 'Tesla Clone',
    category: 'React',
    demo: 'https://github.com/r2r90/TeslaClone',
  },
  {
    id: 3,
    image: Crypto,
    title: 'Cryptocurrency App with Redux Toolkit',
    category: 'React',
    demo: 'https://github.com/r2r90/cryptoverse',
  },
  {
    id: 4,
    image: Exo,
    title: 'e-commerce site web',
    category: 'JavaScript',
    demo: 'https://github.com/r2r90/exo3',
  },

  {
    id: 5,
    image: Citations,
    title: 'Random Citation',
    category: 'JavaScript',
    demo: 'https://github.com/r2r90/citations_projet',
  },
  {
    id: 6,
    image: Jessy,
    title: 'JessStudio',
    category: 'HTML/CSS',
    demo: 'https://github.com/r2r90/JessyStudio',
  },
  {
    id: 7,
    image: Grid,
    title: 'Grid/Flex Page',
    category: 'HTML/CSS',
    demo: 'https://github.com/r2r90/mamon',
  },
  {
    id: 8,
    image: Zoo,
    title: 'Zoo Page',
    category: 'HTML/CSS',
    demo: 'https://github.com/r2r90/projet_zoo',
  },
];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'HTML/CSS',
  },
  {
    name: 'JavaScript',
  },
  {
    name: 'React',
  },
];
